import {
  App,
  LoginMethod,
  routes as allRoutes,
  loginMethod,
} from "@songtradr-sso/shared/common";

// TEXT

// STYLES

// DATA

// TYPES

// CONSTANTS
export const routes = allRoutes[App.Core];

// FUNCTIONS
export const getEmailMode = (
  workspace?: string,
  loginMethods?: LoginMethod[],
) => {
  if (sessionStorage.getItem("email")) return true;
  return (
    Boolean(workspace) &&
    !loginMethods?.some(
      (method: LoginMethod) => method !== loginMethod.Enum.EMAIL_PASSWORD,
    )
  );
};

// ASSETS
